import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {ClrDatagridStateInterface} from '@clr/angular';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {HIUser} from '../../core/HIUser';
import { FormControl } from '@angular/forms';
import { DataService } from 'src/app/core/data.service';
import { Observable } from 'rxjs';
import { Page } from 'src/app/core/Page';
import { Router } from '@angular/router';
import {RestStateInterface} from '../../core/RestStateInterface';

@Component({
  selector: 'user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  selectedUser: HIUser;
  total = 0;
  searchControl: FormControl;
  private debounce = 400;
  users: HIUser[] = [];
  users$: Observable<Page<HIUser>>;
  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dataService: DataService) {}
  ngOnInit() {
    this.searchControl = new FormControl('');
    this.searchControl.valueChanges
        .pipe(debounceTime(this.debounce), distinctUntilChanged())
        .subscribe(query => {
          this.populateUsers(query);
        });
      this.cdr.detectChanges();
    }

    populateUsers(query: string) {
      const state: RestStateInterface = {};
      state.filters = [];
      state.filters.push({'property': 'identifier', 'value': query});
      this.users$ = this.dataService.callGetPaged('user', state);
      this.users$.subscribe(
          x => {
            this.users = x.content;
            this.total = x.totalElements;
          },
          error => {
            console.log(error);
          }
      );
    }

  navToBookings(customerSid: number) {
    this.router.navigate(['/admin/bookStep', {customer: customerSid}]);
  }

  navToPets(customerSid: number) {
    this.router.navigate(['/admin/pets', {customer: customerSid}]);
  }
  navToEdit(customerSid: number) {
    this.router.navigate(['/admin/user', {customer: customerSid}]);
  }


}
